export const AppMessages = {
  Navigation : {
    OpenExpand: 'Expandir',
    CloseExpand: 'Contraer',
  },
  Companies: {
    NOT_FOUND_TITLE: 'Aún no tienes empresas asociadas para esta aplicación',
    NOT_FOUND_DESCRIPTION: 'Empieza a crear empresas y disfruta de los beneficios de usar ',
    SEARCH_PLACEHOLDER: 'Buscar por nombre o razón social, RFC',
  },
  ERROR_GENERIC: 'Error no controlado',
  REINTENT_LABEL: 'Intenta de nuevo más tarde.',
  PARAMS_EMPTY: 'Los parámetros requeridos no están completos.',
  ERROR_CONFIRM_OK: 'Ok',
  ORDER_LABEL: 'Ordenar',
  SEARCH_NOT_FOUNT: 'No se encontraron coincidencias',
};